<template>
  <div>
    <h3>{{ itemsdata.title }}</h3>
    <div v-for="message in itemsdata.messages" :key="message.description">
      <p v-if="message.description">Reason: {{ message.description }}</p>
      <pre class="codearea">{{ message.code }}</pre>
       <p v-if="message.note">Note: {{ message.note }}</p>
      <p v-if="message.solution">Solution: {{ message.solution }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Troubleshooter',
  props: {
    itemsdata: Object
  }
}
</script>

<style scoped>
.codearea {
  background-color: #28292d;
  color: #afb8bb;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/documentation/Troubleshooter.vue